import { mediaCardInit } from "./MediaCard";
import * as themeColors from "@assets/styles/colors.module.scss";
import FeaturedContent from "@/components/FeaturedContent.vue";
const colors = ["None", ...Object.keys(themeColors)];
export const featuredContentInit = {
    component: FeaturedContent,
    name: "Featured Content",
    inputs: [
        {
            name: "title",
            friendlyName: "Title",
            type: "string",
            defaultValue: "Title"
        },
        {
            name: "titleColor",
            type: "string",
            defaultValue: "rothcoBlack",
            enum: colors
        },
        {
            name: "mediaCards",
            friendlyName: "Media Cards",
            type: "array",
            subFields: [...mediaCardInit.inputs]
        },
        {
            name: "isSlider",
            type: "boolean",
            defaultValue: false
        },
        {
            name: "desktopBackgroundImage",
            helperText: "Allowed file types - .jpeg, .png, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "gif", "svg"],
            type: "file"
        },
        {
            name: "mobileBackgroundImage",
            helperText: "Allowed file types - .jpeg, .png, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "gif", "svg"],
            type: "file"
        },
        {
            name: 'hasPadding',
            friendlyName: 'Has Padding',
            type: 'boolean',
            defaultValue: true
        }
    ]
};
